import InternalLinkParser from "@/components/PageEditor/editor-components/shared/InternalLinkParser";
import { useEditor, useNode } from "@craftjs/core";
import ContentEditable from "react-contenteditable";
import Settings from "./Settings";
import Toolbar from "./Toolbar";

interface TextProps {
    text: string;
}

const StepIntro = ({ text = "" }: Partial<TextProps>) => {
    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode();
    const { enabled } = useEditor((s) => ({ enabled: s.options.enabled }));

    if (!enabled)
        return (
            <div ref={(el) => el && connect(el)} className="text-lg/[32px] font-medium mt-2 max-w-[920px]">
                <InternalLinkParser html={text} />
            </div>
        );

    return (
        <div ref={(el) => el && connect(el)} className="text-lg/[32px] font-medium mt-2 max-w-[920px]">
            <ContentEditable
                html={text}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((p: any) => (p.text = e.target.value), 500);
                }}
                tagName="div"
            />
        </div>
    );
};

export default StepIntro;

/* --- craft config ------------------------------------------------------- */

StepIntro.craft = {
    displayName: "Introduction",
    props: {
        text: "Text",
    },
    related: {
        settings: Settings,
        toolbar: Toolbar,
    },
    rules: {
        canDrag: () => false,
        canDrop: () => false,
    },
};
